import React from 'react';
import code1Img from '@/assets/image/code-1.png';
import code2Img from '@/assets/image/code-2.png';

import styles from './index.less';

interface IFooterProps {
}
const Footer: React.FC<IFooterProps> = () => {
  return (
    <div className={styles.footer}>
      <div className={styles.container}>
        <div className={styles.title}>
          大会简介
        </div>
        <div className={styles.desc}>
          中国工业信息安全大会由国家工业信息安全发展研究中心、工业信息安全产业发展联盟联合举办，展现工业信息安全最新发展成果，深化行业交流，提升工业信息安全综合保障能力。
        </div>
        <div className={styles.codes}>
          <div className={styles.code}>
            <img src={code1Img} alt="" />
            <span>国家工业信息安全</span>
            <span>发展研究中心</span>
            <span>官方公众号</span>
          </div>
          <div className={styles.code}>
            <img src={code2Img} alt="" />
            <span>工业信息安全</span>
            <span>发展产业发展联盟</span>
            <span>官方公众号</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
